export default "__VITE_ASSET__BI08KPBp__"